<template lang="pug">
  .container-sysMsg.container-padding
    c-header
      template(slot="left")
        h3 消息通知
    c-box
      el-table(:data="list", fit)
        el-table-column(property="type", label="类型", min-width="200", show-tooltip-when-overflow)
        el-table-column(property="content", label="内容", min-width="150", show-tooltip-when-overflow)
        el-table-column(property="origin", label="来源", min-width="200", show-tooltip-when-overflow)
        el-table-column(property="createDate", label="消息时间", min-width="175", show-tooltip-when-overflow)
</template>

<script>
const staticList = [
  {
    type:         '政策调整',   // 类别
    content:      '应国家有关政策要求，商家在进行网络交易服务过程中，需要提供以下资料：这个，那个，以及那啥',   // 内容
    origin:       '金融平台',   // 来源
    createDate:   '2018-02-29 00:00:00',   // 时间
  },
  {
    type:         '系统消息',   // 类别
    content:      '消息系统测试',   // 内容
    origin:       '金融平台',   // 来源
    createDate:   '2018-02-29 00:00:00',   // 时间
  },
];

export default {
  data () {
    return {
      page:   1,
      size:   5,
      status: 0,
      list:   [],
      total:  0,

      listLoading:  false,
    };
  },
  computed: {

  },
  methods: {

  },
  mounted () {
    this.list = staticList;
  },
};
</script>